export default {
  namespaced: true,
  state: {
    model: null,
    loading: false
  },
  getters: {
    model: (state) => state.model,
    loading: (state) => state.loading
  },
  mutations: {
    set(state, profile) {
      state.model = profile
    },
    setLoading(state, loadingState) {
      state.loading = loadingState
    }
  },
  actions: {
    fetch({ commit }, slug) {
      commit('setLoading', true)
      return Vue.$http.get(`campaigns/${slug}`).then(({ data }) => {
        commit('set', data)
        commit('setLoading', false)
      })
    }
  }
}
